import { environment } from "../environments/environment";
import CryptoJS from 'crypto-js/crypto-js';

export default {

    encryptRequestIfRequired(request){
        if(environment.encryptRequest){
            let encryptDecryptBase64Key = environment.encryptDecryptKey.substring(5, 29);
            let aesKey = window.atob(encryptDecryptBase64Key);
            let ivArray = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
            let iv = CryptoJS.enc.Utf8.parse(this.bin2String(ivArray));
            let requestString = request;
            if(!(typeof request === 'string' || request instanceof String)){
                requestString = JSON.stringify(request)
            }
            let requestArray = this.getByteArray(requestString);
            let combinedArray = ivArray.concat(requestArray);
            let ct = CryptoJS.AES.encrypt(
                this.bin2String(combinedArray),
                CryptoJS.enc.Utf8.parse(aesKey),
                {
                    iv: CryptoJS.enc.Utf8.parse(this.bin2String(iv)),
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                    blockSize: 16,  
                    formatter: CryptoJS.enc.Utf8, 
                }).toString();
            //let ciphertextBase64Encoded = window.btoa(ct);
            return ct;
        }else{
            return request;
        }
    },

    decryptResponseIfRequired(response){
            if(environment.encryptRequest){
                if(response && (typeof response === 'string' || response instanceof String)){
                    //let responseBase64Decode = window.atob(response);
                    let responseBase64DecodeByteArray = this.getByteArray(response);
                    //let responseByteArray = this.getByteArrayFor(responseBase64DecodeByteArray,16,null);
                    let encryptDecryptBase64Key = environment.encryptDecryptKey.substring(5, 29);
                    let aesKey = window.atob(encryptDecryptBase64Key);
                    let ivParams = this.getByteArrayFor(responseBase64DecodeByteArray,0,16);
                    let iv = CryptoJS.enc.Utf8.parse(this.bin2String(ivParams));
                    let decryptedResponseBytes = CryptoJS.AES.decrypt(
                        this.bin2String(responseBase64DecodeByteArray),
                        CryptoJS.enc.Utf8.parse(aesKey),
                        {
                            iv : CryptoJS.enc.Utf8.parse(this.bin2String(iv)),
                            mode: CryptoJS.mode.CBC,
                            padding: CryptoJS.pad.Pkcs7, 
                        }
                    );
                    let decryptedResponse = decryptedResponseBytes.toString(CryptoJS.enc.Utf8);
                    let decryptedResponseByteArray = this.getByteArray(decryptedResponse);
                    let responseByteArray = this.getByteArrayFor(decryptedResponseByteArray,16,null);
                    try {
                        return JSON.parse(this.bin2String(responseByteArray));
                    } catch(e) {
                        return this.bin2String(responseByteArray);
                    }
                    
                }else{
                    return response;
                }
            }else{
                return response;
            }
    },

    getByteArray(base64){
        let len = base64.length;
        let bytes = [];
        for (let i = 0; i < len; i++) {
            bytes[i] = base64.charCodeAt(i);
        }
        return bytes;
    },

    getByteArrayFor(byteArray ,startPosition, endPosition){
        let len = byteArray.length;
        startPosition = !startPosition ? 0 : startPosition;
        endPosition = !endPosition ? len : endPosition;
        let newByteArray = [];
        for (let i = startPosition; i < endPosition; i++) {
            newByteArray[i-startPosition] = byteArray[i];
        }
        return newByteArray;
    },

    bin2String(array) {
        let result = "";
        for (let i = 0; i < array.length; i++) {
            result += String.fromCharCode(parseInt(array[i]));
        }
        return result;
    },

    hash256(data) {
        return CryptoJS.SHA256(data).toString();
    }
}